import AddEditPanelContainer from "../../../containers/add-edit-panel";
import AddEditPanel from "./add-edit-panel";
import { service, dropdowns } from "../data";

export default AddEditPanelContainer(AddEditPanel, { dropdowns, service });
